import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import colors from '@/design/colors';

const styles = StyleSheet.create({
  itemList: {
    flexDirection: 'column',
    rowGap: 16,
  },
  itemName: {
    color: colors.blackAlpha100,
    fontWeight: 600,
  },
  itemDescription: {
    color: colors.gray300,
  },
});

interface ItemListProps {
  items: { name: string; description?: string }[];
}

const ItemList: React.FC<ItemListProps> = ({ items }) => (
  <View style={styles.itemList}>
    {items.map(({ name, description }) => (
      <View>
        <Text style={styles.itemName}>{name}</Text>
        {description && (
          <Text style={styles.itemDescription}>{description}</Text>
        )}
      </View>
    ))}
  </View>
);

export default ItemList;
